<template>
  <b-form>
    <div class="row mb-3">
      <div class="col-md-6 mb-3">
        <label for="instansi_pemohon">Nama Pemohon</label>
        <b-form-input
          id="instansi_pemohon"
          v-model="dataPermohonan.instansi_pemohon"
          name="Nama Pemohon"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="nik">NIK Pemohon</label>
        <b-form-input
          id="nik"
          v-model="dataPermohonan.nik_pemohon"
          name="NIK Pemohon"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="email">Email Pemohon</label>
        <b-form-input
          id="email"
          v-model="dataPermohonan.email_pemohon"
          name="Email"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="alamat_kantor">Alamat Pemohon</label>
        <b-form-input
          id="alamat_kantor"
          v-model="dataPermohonan.alamat_pemohon"
          name="Alamat Pemohon"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="nomor_permohonan">Nomor Permohonan</label>
        <b-form-input
          id="nomor_permohonan"
          v-model="dataPermohonan.nomor_permohonan"
          name="Nomor Permohonan"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="npwp">NPWP</label>
        <b-form-input
          id="npwp"
          v-model="dataPermohonan.npwp_pemohon"
          v-mask="'##.###.###.#-###.####'"
          name="NPWP"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div v-if="jenisPermohonan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="nib">NIB</label>
        <b-form-input
          id="nib"
          v-model="dataPermohonan.nib_pemohon"
          name="NIB"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div v-if="jenisPermohonan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="nomor_proyek">Nomor Proyek</label>
        <b-form-input
          id="nomor_proyek"
          v-model="dataPermohonan.nomor_proyek"
          name="Nomor Proyek"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="sektor">Sektor</label>
        <b-form-input
          id="sektor"
          v-model="dataPermohonan.klasifikasi_pemohon"
          name="Sektor"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div v-if="jenisPermohonan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="kode_kbli">KBLI</label>
        <v-select
          id="kode_kbli"
          v-model="dataPermohonan.kbli"
          :reduce="(data) => data.kode"
          label="kode_deskripsi"
          :options="dataKBLI"
          multiple
          name="KBLI"
          style="opacity: 0.7"
          disabled
        />
      </div>
      <div class="col-md-6 mb-3">
        <label for="tanggal_permohonan">Tanggal Permohonan</label>
        <b-form-input
          type="date"
          id="tanggal_permohonan"
          v-model="dataPermohonan.tanggal_permohonan"
          name="Tanggal Permohonan"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="jenis_kegiatan">Jenis Kegiatan</label>
        <b-form-input
          id="jenis_kegiatan"
          v-model="dataPermohonan.jenis_kegiatan"
          name="Jenis Kegiatan"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="lokasi">Lokasi</label>
        <b-form-input
          id="lokasi"
          v-model="dataPermohonan.lokasi"
          name="Lokasi"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div v-if="jenisPermohonan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="jenis_proyek">Jenis Proyek</label>
        <b-form-input
          id="jenis_proyek"
          v-model="dataPermohonan.jenis_proyek"
          name="Jenis Proyek"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div v-if="jenisPermohonan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="risiko">Risiko</label>
        <b-form-input
          id="risiko"
          v-model="dataPermohonan.risiko"
          name="Risiko"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div v-if="jenisPermohonan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="skala_usaha">Skala Usaha</label>
        <b-form-input
          id="skala_usaha"
          v-model="dataPermohonan.skala_usaha"
          name="Skala Usaha"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="potensi_pnbp">Potensi PNBP</label>
        <b-form-input
          id="potensi_pnbp"
          v-model="dataPermohonan.potensi_pnbp"
          name="Potensi PNBP"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="tanggal_proses">Tanggal Proses</label>
        <b-form-input
          type="date"
          id="tanggal_proses"
          v-model="dataPermohonan.tanggal_proses"
          name="Tanggal Proses"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="reklamasi">Reklamasi</label>
        <v-select
          id="reklamasi"
          v-model="dataPermohonan.reklamasi"
          :options="[
            { value: true, text: 'Ya' },
            { value: false, text: 'Tidak' },
          ]"
          name="Reklamasi"
          style="opacity: 0.7"
          disabled
        />
      </div>
      <div class="col-md-6 mb-3">
        <label for="psn">PSN</label>
        <b-form-input
          id="psn"
          v-model="dataPermohonan.psn"
          name="PSN"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div v-if="jenisPermohonan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="bentuk_usaha">Bentuk Usaha</label>
        <b-form-input
          id="bentuk_usaha"
          v-model="dataPermohonan.bentuk_usaha"
          name="Bentuk Usaha"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="jenis_pnbp">Jenis Permohonan</label>
        <v-select
          id="jenis_pnbp"
          v-model="dataPermohonan.jenis_pnbp"
          :options="[
            'Area',
            'Kabel Bawah Laut',
            'Pipa Air Bersih / Air Baku',
            'Pipa Selain Air Bersih / Air Baku',
          ]"
          name="Jenis Permohonan"
          multiple
          style="opacity: 0.7"
          disabled
        />
      </div>
      <div
        v-if="dataPermohonan.jenis_pnbp?.includes('Area')"
        class="col-md-6 mb-3"
      >
        <label for="luas">Luas (ha)</label>
        <b-form-input
          id="luas"
          v-model="dataPermohonan.luas"
          name="Luas"
          type="number"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div
        v-if="dataPermohonan.jenis_pnbp?.includes('Kabel Bawah Laut')"
        class="col-md-6 mb-3"
      >
        <label for="panjang_konservasi_kabel">
          Panjang Kabel (di dalam Kws. Konservasi) (km)
        </label>
        <b-form-input
          id="panjang_konservasi_kabel"
          v-model="dataPermohonan.panjang_konservasi_kabel"
          name="Panjang Kabel (Dalam Kawasan)"
          type="number"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div
        v-if="dataPermohonan.jenis_pnbp?.includes('Kabel Bawah Laut')"
        class="col-md-6 mb-3"
      >
        <label for="panjang_nonkonservasi_kabel">
          Panjang Kabel (di luar Kws. Konservasi) (km)
        </label>
        <b-form-input
          id="panjang_nonkonservasi_kabel"
          v-model="dataPermohonan.panjang_nonkonservasi_kabel"
          name="Panjang Kabel (Luar Kawasan)"
          type="number"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div
        v-if="dataPermohonan.jenis_pnbp?.includes('Pipa Air Bersih / Air Baku')"
        class="col-md-6 mb-3"
      >
        <label for="panjang_konservasi_pipa_air">
          Panjang Pipa Air Bersih (di dalam Kws. Konservasi) (km)
        </label>
        <b-form-input
          id="panjang_konservasi_pipa_air"
          v-model="dataPermohonan.panjang_konservasi_pipa_air"
          name="Panjang Pipa (Dalam Kawasan)"
          type="number"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div
        v-if="dataPermohonan.jenis_pnbp?.includes('Pipa Air Bersih / Air Baku')"
        class="col-md-6 mb-3"
      >
        <label for="panjang_nonkonservasi_pipa_air">
          Panjang Pipa Air Bersih (di luar Kws. Konservasi) (km)
        </label>
        <b-form-input
          id="panjang_nonkonservasi_pipa_air"
          v-model="dataPermohonan.panjang_nonkonservasi_pipa_air"
          name="Panjang Pipa (Luar Kawasan)"
          type="number"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div
        v-if="
          dataPermohonan.jenis_pnbp?.includes(
            'Pipa Selain Air Bersih / Air Baku',
          )
        "
        class="col-md-6 mb-3"
      >
        <label for="panjang_konservasi_pipa_lain">
          Panjang Pipa Selain Air Bersih (di dalam Kws. Konservasi) (km)
        </label>
        <b-form-input
          id="panjang_konservasi_pipa_lain"
          v-model="dataPermohonan.panjang_konservasi_pipa_lain"
          name="Panjang Pipa Selain Air Bersih (Dalam Kawasan)"
          type="number"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div
        v-if="
          dataPermohonan.jenis_pnbp?.includes(
            'Pipa Selain Air Bersih / Air Baku',
          )
        "
        class="col-md-6 mb-3"
      >
        <label for="panjang_nonkonservasi_pipa_lain">
          Panjang Pipa Selain Air Bersih (di luar Kws. Konservasi) (km)
        </label>
        <b-form-input
          id="panjang_nonkonservasi_pipa_lain"
          v-model="dataPermohonan.panjang_nonkonservasi_pipa_lain"
          name="Panjang Pipa Selain Air Bersih (Luar Kawasan)"
          type="number"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div class="col-md-6 mb-3">
        <label for="kedalaman">Kedalaman (m)</label>
        <b-form-input
          id="kedalaman"
          v-model="dataPermohonan.kedalaman"
          name="Kedalaman"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div v-if="jenisPermohonan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="kategori_permohonan">Kategori Permohonan</label>
        <b-form-input
          id="kategori_permohonan"
          v-model="dataPermohonan.kategori_permohonan"
          name="Kategori Permohonan"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div v-if="jenisPermohonan === 'Berusaha'" class="col-md-6 mb-3">
        <label for="tipe_permohonan">Tipe Permohonan</label>
        <b-form-input
          id="tipe_permohonan"
          v-model="dataPermohonan.tipe_permohonan"
          name="Tipe Permohonan"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div
        v-if="dataPermohonan.tipe_permohonan === 'Multi KBLI'"
        class="col-md-6 mb-3"
      >
        <label for="tipe_multi_kbli">Tipe Multi KBLI</label>
        <b-form-input
          id="tipe_multi_kbli"
          v-model="dataPermohonan.tipe_multi_kbli"
          name="Tipe Multi KBLI"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
      <div
        v-if="dataPermohonan.tipe_multi_kbli === 'Mengikuti'"
        class="col-md-6 mb-3"
      >
        <label for="nomor_permohonan_utama">Nomor Permohonan Utama</label>
        <b-form-input
          id="nomor_permohonan_utama"
          v-model="dataPermohonan.nomor_permohonan_utama"
          name="Tipe Multi KBLI"
          style="opacity: 0.7"
          disabled
        ></b-form-input>
      </div>
    </div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import axios from 'axios'

export default {
  components: { vSelect, DatePicker },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      dataPermohonan: {},
      jenisPermohonan: '',
      dataKBLI: [],
      dataProvinsi: [],
    }
  },
  methods: {
    async nextForm() {
      return true
    },

    async loadData() {
      const id = this.$route.query.id_pemutakhiran
      if (!id) {
        this.$router.push('/app/pencabutan')
        return
      }

      const res = await axios.get(
        `${this.baseapi}api/pencabutan/${id}`,
        this.getApiOption(),
      )
      const jenisPermohonan = res.data.data.jenis_permohonan
      const nomorIzin = res.data.data.nomor_izin_terbit
      this.jenisPermohonan = jenisPermohonan

      const api =
        jenisPermohonan === 'Berusaha'
          ? `${this.baseapi}api/permohonan/dataTable?filter=nomor_oss,=,${nomorIzin}`
          : `${this.baseapi}api/permohonan_nonberusaha/dataTable?filter=nomor_kkp,=,${nomorIzin}`
      const res2 = await axios.get(api, this.getApiOption())
      const resData2 = res2.data.data[0]
      this.dataPermohonan = {
        ...resData2,
        instansi_pemohon: resData2.instansi_pemohon || resData2.nama_pemohon,
        lokasi: resData2.lokasi || resData2.provinsi,
        tanggal_permohonan:
          resData2.tanggal_permohonan || resData2.tanggal_pada_permohonan,
      }
    },

    getKBLI() {
      axios
        .get(this.baseapi + 'api/kbli', this.getApiOption())
        .then((response) => {
          this.dataKBLI = response.data.data
        })
    },

    getProvinsi() {
      axios
        .get(this.baseapi + 'api/provinsi?sort=id,ASC', this.getApiOption())
        .then((response) => {
          this.dataProvinsi = response.data.data
        })
    },

    getApiOption() {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
      }
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>
